import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { buildFleetQuery } from '../_shared/utils/fleet-query';

@Injectable({
  providedIn: 'root'
})
export class FleetDutyCycleFigureService {
  
  constructor(private readonly httpClient: HttpClient) { }
  
  getTemperatureComfortZoneUsageFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'temperature-comfort-zone-fleet?' + buildFleetQuery(fleetId, batteryType));
  }
  
  getTimeSpentChargingExtremeTemperatureFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'time-charging-extreme-temp-fleet?' + buildFleetQuery(fleetId, batteryType));
  }
  
  getTimeSpentExtremeTemperatureFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'datapoints-time-extreme-temp-fleet?' + buildFleetQuery(fleetId, batteryType));
  }

  getTimeSpentExtremeHighTemperatureFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'time-extreme-high-temp-fleet?' + buildFleetQuery(fleetId, batteryType));
  }

  getTimeSpentExtremeBelowTemperatureFleet(fleetId: string[], batteryType?: string[]): Observable<any> {
    return this.httpClient.get<any>(environment.apiEndpoint + 'time-extreme-low-temp-fleet?' + buildFleetQuery(fleetId, batteryType));
  }
}